
import { Component, Prop } from 'vue-property-decorator';
import NumberField from './NumberField.vue';

@Component
export default class CurrencyField extends NumberField
{
  /**
   * The number style to use. Must be one of i18n.$numberFormats or a Intl.NumberFormat options object.
   */
  @Prop({ default: 'currency' })
  public readonly format: string | Intl.NumberFormatOptions;
}
